import "@lmax-exchange/lmax-common-ui/styles.css";
import { getMSW } from "./mocks/browser.ts";
import type { Plugin } from "vue";
import "@/assets/styles/index.css";
import { createAuthService } from "./services/auth";
import { getMockMode } from "@/config/apiClient.config";
import * as Sentry from "@sentry/vue";
import { loadConfig } from "@/services/config.ts";

(async () => {
  await loadConfig();

  if (getMockMode()) {
    await getMSW().start();
  }

  const { createApp } = await import("vue");
  const { createPinia } = await import("pinia");
  const { components: CommonUI } = await import(
    "@lmax-exchange/lmax-common-ui"
  );

  const App = (await import("./App.vue")).default;
  const router = (await import("./router.ts")).default;

  const app = createApp(App);
  const pinia = createPinia();

  if (
    import.meta.env.PROD &&
    window.location.hostname.match(/.*.?custody\.lmax\.com/)
  ) {
    const environment =
      window.location.hostname
        .replace("custody.lmax.com", "")
        .replace(".", "") || "production";

    Sentry.init({
      app,
      dsn: "https://d7bdef6548a9ad15b3e2a6684353e542@o4504994517745664.ingest.us.sentry.io/4509712676356096",
      sendDefaultPii: true,
      integrations: [Sentry.eventFiltersIntegration()],
      environment: environment,
    });
  }

  app.use(pinia);

  const authService = createAuthService();
  router.beforeEach(async (to, _from) => {
    return await authService.authGuard(to);
  });
  app.use(router);
  app.use(CommonUI as unknown as Plugin);

  if (authService.install) {
    app.use(authService as unknown as Plugin);
  }

  app.mount("#app");
})();
